import { useState, useRef, useEffect } from "react";
import { MessageSquare, X, Send, Bot } from "lucide-react";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

const sid = () => {
  let s = localStorage.getItem("ll_chat_sid");
  if (!s) { s = "sess-" + Math.random().toString(36).slice(2); localStorage.setItem("ll_chat_sid", s); }
  return s;
};

export const ChatWidget = () => {
  const s = useSettings();
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([{ role: "assistant", text: "Halo! Saya Lentera AI 🌸. Ada yang bisa saya bantu seputar layanan CCTV AI, Bot, atau digitalisasi bisnis Anda?" }]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, open]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    setInput("");
    setMsgs((m) => [...m, { role: "user", text }]);
    setLoading(true);
    try {
      const { data } = await api.post("/chat", { session_id: sid(), message: text });
      setMsgs((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch {
      setMsgs((m) => [...m, { role: "assistant", text: "Maaf, terjadi kendala. Silakan hubungi kami via WhatsApp." }]);
    } finally { setLoading(false); }
  };

  const wa = s.whatsapp || "6281234567890";

  return (
    <>
      <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
        <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" data-testid="whatsapp-button"
          className="glass gold-border rounded-full pl-2 pr-4 py-2 flex items-center gap-2.5 text-sm hover:border-[#25D366] group shadow-lg">
          <span className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center text-white font-bold text-lg">W</span>
          <span className="text-white/90 leading-tight text-left">Chat Admin<br/><span className="text-[10px] text-green-400">Online · Klik untuk chat</span></span>
        </a>
        {!open && (
          <button onClick={() => setOpen(true)} data-testid="ai-chat-toggle-button"
            className="btn-gold w-14 h-14 rounded-full flex items-center justify-center animate-pulse-glow shadow-lg">
            <MessageSquare className="w-6 h-6" />
          </button>
        )}
      </div>

      {open && (
        <div className="fixed bottom-5 right-5 z-[70] w-[92vw] max-w-sm h-[70vh] max-h-[560px] glass rounded-2xl flex flex-col overflow-hidden gold-border" data-testid="ai-chat-window">
          <div className="flex items-center justify-between p-4 border-b border-amber-500/15 bg-[#0F1117]">
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-full btn-gold flex items-center justify-center"><Bot className="w-5 h-5" /></div>
              <div><div className="font-syne font-bold text-white text-sm">Lentera AI</div><div className="text-[10px] text-green-400">● Online 24/7</div></div>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/60 hover:text-white" data-testid="ai-chat-close"><X className="w-5 h-5" /></button>
          </div>
          <div className="flex-1 overflow-y-auto p-4 space-y-3">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[80%] px-3.5 py-2.5 rounded-2xl text-sm ${m.role === "user" ? "btn-gold rounded-br-sm" : "bg-white/5 text-white/90 rounded-bl-sm border border-white/10"}`}>{m.text}</div>
              </div>
            ))}
            {loading && <div className="text-white/50 text-sm px-3">Lentera AI sedang mengetik…</div>}
            <div ref={endRef} />
          </div>
          <div className="p-3 border-t border-amber-500/15 flex gap-2">
            <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Tulis pesan…" data-testid="ai-chat-input"
              className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-2.5 text-sm text-white outline-none focus:border-gold" />
            <button onClick={send} className="btn-gold w-11 h-11 rounded-full flex items-center justify-center shrink-0" data-testid="ai-chat-send"><Send className="w-4 h-4" /></button>
          </div>
        </div>
      )}
    </>
  );
};
